<template>
  <div :class="{ isFrame, isWideScreen: parentWidth > 600, isNarrowTop }">
    <div id="page-index" v-if="is_show_home == 1" v-show="indexShow">
      <div id="swiperDiv">
        <img
          id="basicImg"
          src="@/assets/images/reserveBanner_fix_750-460.png"
        />
        <div class="swiper-container" id="indexSwiper">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in banner_data" :key="index">
              <img
                src="@/assets/images/reserveBanner_fix_750-460.png"
                :style="{ backgroundImage: 'url(' + item.image + ')' }"
              />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
      <div id="reservation-banner-preview">
        <div class="phone-button-col">
          <button
            type="button"
            class="btn btn-warning"
            @click="go2AddReservation"
          >
            PLACE A RESERVATION
          </button>
        </div>

        <div class="preview-grid" id="addressCol" @click="getMap">
          <div class="title-icon">
            <a-icon
              type="environment"
              theme="twoTone"
              two-tone-color="#0f894d"
            />
          </div>
          <div class="address-col" v-html="address"></div>
          <a-icon type="right" />
        </div>

        <div class="preview-grid" id="expensive-col">
          <div class="title-icon">
            <span>£</span>
          </div>
          <div class="expensive-right-col">
            <a-rate character="£" :default-value="expensive_rate" disabled />
          </div>
        </div>

        <div class="words-mod" id="reservation-restaurant_info-col">
          <h4>Restaurant info</h4>
          <div class="infoCheck-col">
            <div
              class="infoCheckPreview"
              v-for="(info, index) in info"
              :key="index"
            >
              <a-icon type="check" v-if="info.status == 1" />
              <a-icon type="close" v-else />
              <label class="inputLabel">{{ info.name | getInfoName }}</label>
            </div>
          </div>
        </div>
        <div class="words-mod" id="reservation-notes-col">
          <h4>Notes</h4>
          <div class="words" data-id="notes" id="notes-words-col">
            {{ notes }}
          </div>
        </div>
      </div>
      <Map
        :mapShow.sync="mapShow"
        :locationLat="locationLat"
        :locationLng="locationLng"
        :address="address"
        :storeName="storeName"
      ></Map>
    </div>
    <loading v-show="loadingShow"></loading>

    <div id="reservation" v-show="reservationShow && !modalShow">
      <div class="page-container" id="reservation-container">
        <div class="page-content" id="reservation-content">
          <header id="main-menu" class="logo-header">
            <div class="store-info menu-content">
              <div class="logo-col">
                <img :src="storeLogo" />
              </div>
              <div class="store-name">
                <h1>{{ storeName }}</h1>
              </div>
            </div>
          </header>
          <nav id="main-nav" class="detail-nav">
            <div class="reservation-tips-grid">
              <div class="tip-grid-col">
                <div>
                  <span class="icon-users"></span>
                  <input
                    type="hidden"
                    name="covers"
                    id="covers"
                    v-model="currentSize"
                  />
                  <div id="grid-number-col" class="tip-grid-col-bottom">
                    {{ currentSize }}
                  </div>
                </div>
              </div>
              <div class="tip-grid-col">
                <div>
                  <span class="icon-calendar-alt-fill"></span>
                  <input type="hidden" name="date" id="date" />
                  <div id="grid-date-col" class="tip-grid-col-bottom">
                    {{ currentDate }}
                  </div>
                </div>
              </div>
              <div class="tip-grid-col">
                <div>
                  <span class="icon-clock2"></span>
                  <div
                    id="grid-time-col"
                    class="tip-grid-col-bottom"
                    data-sort=""
                    data-tab="0"
                    data-time-tab="0"
                  >
                    {{ currentTime }}
                  </div>
                  <input type="hidden" name="time" id="time" />
                  <input type="hidden" name="table_id" id="table_id" />
                  <input type="hidden" name="session_id" id="session_id" />
                </div>
              </div>
            </div>
          </nav>
          <article class="swiper-container" id="swiper-container">
            <div class="swiper-wrapper">
              <section
                id="page-1"
                class="swiper-slide swiper-no-swiping"
                v-show="currentPage === 0"
              >
                <div class="step-title">
                  <h3>Select Party Size</h3>
                </div>
                <div id="selectPartySize-mod">
                  <div v-if="isShowCustomSize">
                    <a-input-number
                      class="custom-size-input"
                      type="number"
                      size="large"
                      :min="1"
                      :max="maxCovers"
                      v-model="tempCustomSize"
                      @change="changeCustomSize"
                    ></a-input-number>
                  </div>

                  <template v-else>
                    <div
                      v-if="maxCovers < 9"
                      class="radioButtonCol"
                      data-toggle="buttons"
                    >
                      <label
                        class="btn btn-shadow partySizeLabel"
                        v-for="(item, index) in sizeArr"
                        :key="index"
                        @click="changeSize(item, index)"
                      >
                        <input
                          name="partySize"
                          type="radio"
                          autocomplete="off"
                          :value="item"
                        />{{ item }}</label
                      >
                      <label
                        class="btn btn-shadow partySizeLabel"
                        @click="largerBookBtn"
                      >
                        <input type="radio" autocomplete="off" />Other</label
                      >
                    </div>

                    <div
                      v-if="maxCovers >= 9"
                      class="radioButtonCol"
                      data-toggle="buttons"
                    >
                      <label
                        class="btn btn-shadow partySizeLabel"
                        v-for="(item, index) in defaultCovers"
                        :key="index"
                        @click="changeSize(item, index)"
                      >
                        <input
                          name="partySize"
                          type="radio"
                          autocomplete="off"
                          :value="item"
                        />{{ item }}</label
                      >
                      <span class="morePersonCol">
                        <label
                          class="btn btn-shadow partySizeLabel full-block mb20"
                          style=""
                        >
                          <input
                            id="custom_cover"
                            name="partySize"
                            type="radio"
                            autocomplete="off"
                            value="0"
                            @click="startCustomSize()"
                          />Custom Party Size
                        </label>
                        <label
                          class="btn btn-shadow partySizeLabel full-block"
                          @click="largerBookBtn"
                        >
                          <input type="radio" autocomplete="off" />Other</label
                        >
                      </span>
                    </div>
                  </template>

                  <div class="tipsCol">
                    For larger bookings or if you are unable to find a suitable
                    time, please call the venue directly on
                    <a :href="`tel:` + storePhone">{{ storePhone }}</a
                    >.
                    <!-- Or fill in a <a @click='largerBookBtn' href="javascript:void(0)">custom booking enquiry</a> -->
                  </div>
                </div>
              </section>
              <section
                id="page-2"
                class="swiper-slide swiper-no-swiping"
                v-show="currentPage === 1"
              >
                <div class="step-title">
                  <h3>Select Date</h3>
                </div>
                <div id="calendar-modal">
                  <div id="dateSelect-calendar"></div>
                </div>
              </section>
              <section
                id="page-3"
                class="swiper-slide swiper-no-swiping"
                v-show="currentPage === 2"
              >
                <div class="step-title">
                  <h3>Select Time</h3>
                </div>
                <div id="selectTime-mod">
                  <div id="tab-container" class="tab-container">
                    <ul class="etabs">
                      <li
                        class="tab"
                        v-for="(item, index) in sessionArr"
                        :key="index"
                        @click="timeTabs(index)"
                        :class="{ active: index === timeActive }"
                      >
                        <a href="javascript:void(0)">{{ item.name }}</a>
                      </li>
                    </ul>
                    <div class="panel-container">
                      <div
                        id="tabs1-Breakfast"
                        class="radioButtonCol thishide"
                        v-if="is_holding_time != 1"
                        data-toggle="buttons"
                      >
                        <label
                          class="btn btn-outline timeLabel"
                          :class="{
                            cannotClick: item.show != 1,
                            canClick: item.show === 1,
                          }"
                          v-for="(item, index) in timeArr"
                          :key="index"
                          @click="
                            selectTime(
                              item.time,
                              index,
                              0,
                              item.table_id,
                              item.show
                            )
                          "
                        >
                          <input
                            name="reserveTime"
                            type="radio"
                            autocomplete="off"
                            :value="item.time"
                          />{{ item.time }}
                        </label>
                      </div>
                      <div
                        id="tabs1-Breakfast"
                        class="radioButtonCol thishide"
                        v-if="is_holding_time === 1"
                        data-toggle="buttons"
                      >
                        <label
                          class="btn btn-outline timeLabel minPaddingBtn"
                          :class="{
                            cannotClick: item.show != 1,
                            canClick: item.show === 1,
                          }"
                          v-for="(item, index) in timeArr"
                          :key="index"
                          @click="
                            chooseTime(
                              item.time,
                              index,
                              0,
                              item.table_id,
                              item.show
                            )
                          "
                        >
                          <input
                            name="reserveTime"
                            type="radio"
                            autocomplete="off"
                            :value="item.time"
                          />{{ item.time }}
                          <span>{{ duration | getTimeLengthFormat }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                id="page-4"
                class="swiper-slide swiper-no-swiping"
                v-show="currentPage === 3"
              >
                <!-- <div class="step-title">
                  <h3>Customer Information</h3>
                </div> -->
                <div id="customerDetails-mod">
                  <form
                    id="reservationForm"
                    ref="reservationForm"
                    method="post"
                  >
                    <div class="formCol">
                      <label class="requiredLabel" for="first_name"
                        >First Name</label
                      >
                      <div class="input-group">
                        <input
                          class="form-control"
                          placeholder="First Name"
                          v-model="infoForm.firstName"
                          type="text"
                          id="first_name"
                          name="first_name"
                          required
                        />
                      </div>
                    </div>

                    <div class="formCol">
                      <label class="requiredLabel" for="Surname">Surname</label>
                      <div class="input-group">
                        <input
                          class="form-control"
                          placeholder="Surname"
                          v-model="infoForm.surname"
                          type="text"
                          id="surname"
                          name="surname"
                          required
                        />
                      </div>
                    </div>

                    <div class="formCol">
                      <label class="requiredLabel" for="phone"
                        >Mobile Phone</label
                      >
                      <div class="phoneNumberCol">
                        <div class="dropdown" id="mobile_areaCode">
                          <button
                            class="btn btn-secondary dropdown-toggle"
                            id="mobile_areaCode-col"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {{ country }}
                          </button>
                          <AreaCodeWithSearch
                            :areaCode="areaCode"
                            :country="country"
                            @getAreaCode="getAreaCode"
                          >
                          </AreaCodeWithSearch>
                        </div>
                        <input
                          v-model="areaCode"
                          type="hidden"
                          id="area_code"
                          name="area_code"
                        />
                        <div class="input-group">
                          <input
                            class="form-control"
                            placeholder="Phone Number: 07590012345"
                            v-model="infoForm.phone"
                            type="tel"
                            id="phone"
                            name="phone"
                            required
                            oninput="value=value.replace(/[^\d]/g,'')"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="formCol">
                      <label class="requiredLabel" for="email">Email</label>
                      <div class="input-group">
                        <input
                          class="form-control"
                          placeholder="Email"
                          v-model="infoForm.email"
                          type="email"
                          id="email"
                          name="email"
                          required
                        />
                      </div>
                    </div>

                    <div class="formCol" v-if="allergy_show === 1">
                      <label>Allergens</label>
                      <div class="input-group">
                        <input
                          class="form-control"
                          v-model="infoForm.allergy"
                          type="text"
                          id="allergy_data"
                          name="allergy"
                        />
                        <a
                          href="javascript:void(0)"
                          @click="allergySelect"
                          id="allergyEditLink"
                          data-target="#modal-ajax"
                          data-toggle="modal"
                        ></a>
                      </div>
                    </div>

                    <div class="formCol">
                      <label for="email">Note</label>
                      <div class="input-group">
                        <textarea
                          id="customerNoteTextarea"
                          rows="4"
                          cols="8"
                          name=""
                          v-model="infoForm.remark"
                          class="form-control customerNote"
                          placeholder="Let us know if it's a special event or if you have any specific dietary requirements."
                        ></textarea>
                      </div>
                    </div>
                  </form>
                </div>
              </section>
              <section
                id="page-5"
                class="swiper-slide swiper-no-swiping"
                v-show="currentPage === 4"
              >
                <div class="orderDetial-mod">
                  <div id="orderDetial-mod">
                    <ul class="order-details">
                      <li class="name-col">
                        <div class="col-label">Name:</div>
                        <strong id="orderName">
                          <span id="orderFirstName">{{
                            infoForm.firstName
                          }}</span
                          >&nbsp;<span id="orderLastName">{{
                            infoForm.surname
                          }}</span>
                        </strong>
                      </li>
                    </ul>
                    <ul class="order-details">
                      <li class="email-col">
                        <div class="col-label">Email:</div>
                        <strong id="orderEmail">{{ infoForm.email }}</strong>
                      </li>
                    </ul>
                    <ul class="order-details">
                      <li class="phone-col">
                        <div class="col-label">Phone:</div>
                        <strong id="orderPhone">
                          <span
                            v-show="
                              infoForm.areaCode !== '' ||
                              infoForm.areaCode !== ' '
                            "
                            >{{ infoForm.areaCode }}
                          </span>
                          {{ infoForm.phone }}
                        </strong>
                      </li>
                    </ul>
                    <ul
                      class="order-details flex"
                      id="depositCol"
                      v-show="depositPrice !== ''"
                    >
                      <li class="deposit-col flex3">
                        <div class="col-label">Deposit:</div>
                        <strong id="orderDeposit"
                          >&pound;{{ depositPrice }}</strong
                        >
                      </li>
                      <li class="people-col flex1">
                        <div class="col-label">People:</div>
                        <strong id="orderPeople">{{ currentSize }} px</strong>
                      </li>
                    </ul>
                    <ul class="order-details flex">
                      <li class="date-col flex2">
                        <div class="col-label">Date:</div>
                        <strong id="orderDate">{{ currentDate }}</strong>
                      </li>
                      <li class="week-col flex1">
                        <div class="col-label">On:</div>
                        <strong id="orderWeek">{{ week }}</strong>
                      </li>
                      <li class="time-col flex1">
                        <div class="col-label">Time:</div>
                        <strong id="orderTime">{{ currentTime }}</strong>
                      </li>
                    </ul>
                  </div>
                  <div class="readTermRadioCol">
                    <a-radio @click="readNot"
                      >I have read
                      <a
                        id="modalLink"
                        @click="termsAndConditions"
                        href="javascript:void(0)"
                        data-target="#modal-ajax"
                        data-toggle="modal"
                        >Booking Terms and Conditions</a
                      >.</a-radio
                    >
                  </div>
                  <div class="otherCheckboxCol">
                    <label class="p"
                      >I would like to receive news and offers from
                      {{ storeName }} by:</label
                    >
                    <div class="type-grid">
                      <div class="checkbox checkbox-info">
                        <input
                          id="fromStore_type-email"
                          type="checkbox"
                          value="1"
                          @click="setSendEmail"
                        />
                        <label for="fromStore_type-email">Email</label>
                      </div>
                      <div class="checkbox checkbox-info">
                        <input
                          id="fromStore_type-sms"
                          type="checkbox"
                          value="1"
                          @click="setSendSms"
                        />
                        <label for="fromStore_type-sms">SMS</label>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                id="page-5-1"
                class="swiper-slide swiper-no-swiping"
                v-show="currentPage === 5"
              >
                <div class="step-title">
                  <h3>Deposite</h3>
                </div>
                <div id="depositeDetails-mod">
                  <div class="title">
                    <h5>
                      Add A Deposit for
                      <span id="customerName"
                        >{{ infoForm.firstName }}&nbsp;{{
                          infoForm.surname
                        }}</span
                      >'s Booking
                    </h5>
                  </div>
                  <form id="depositCreateForm">
                    <div
                      class="radioButtonCol"
                      data-toggle="buttons"
                      id="depositTypeCol"
                    >
                      <label
                        :for="item"
                        class="btn btn-outline btn-inverse depositLabel"
                        v-for="(item, index) in depositeArr"
                        :key="index"
                        @click="depositeTabs(item)"
                      >
                        <input
                          :id="item"
                          name="payment"
                          type="radio"
                          autocomplete="off"
                        />{{ item }}
                      </label>
                    </div>
                    <div class="widget-body">
                      <div
                        id="depositContent"
                        v-show="
                          deposite === 'Card' ||
                          deposite === 'Cash' ||
                          deposite === ''
                        "
                      >
                        <ul>
                          <li>
                            <div class="nameCol">Deposit Per Head</div>
                            <div class="numberCol">
                              &pound;<span id="price">50.00</span>
                            </div>
                          </li>
                          <li>
                            <div class="nameCol">Number of Guests</div>
                            <div class="numberCol" id="partySize">
                              {{ currentSize }}
                            </div>
                          </li>
                          <li>
                            <div class="nameCol totalCol">Total</div>
                            <div class="numberCol" id="totalCol">
                              <span class="pound-col">&pound;</span
                              ><span id="total">{{ 50.0 * currentSize }}</span>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <input type="hidden" name="user_id" value="" />
                      <input type="hidden" name="reserve_id" value="" />
                      <input type="hidden" name="money" id="money" value="" />
                      <input
                        type="hidden"
                        name="payment"
                        id="payment"
                        value=""
                      />
                      <div
                        id="emptyCol"
                        class=""
                        v-show="
                          deposite === 'Poynt' || deposite === 'Paymentsense'
                        "
                      >
                        <img src="../assets/images/deposit_none2.svg" />
                        <h6>
                          Oh-uh, you dont seem to have
                          <span>{{ deposite }}</span> activated.
                        </h6>
                        <p>
                          Please contact support to enable
                          <span>{{ deposite }}</span
                          >.
                        </p>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="swiper-pagination" v-if="currentPage === 5">
                  <button
                    v-show="deposite === 'Card' || deposite === 'Cash'"
                    @click="next"
                    id="nextToSelectSubmit"
                    class="btn btn-success nextBtn nextBtn-success"
                    data-style="expand-left"
                    type="button"
                  >
                    <span class="ladda-label">NEXT</span>
                  </button>
                </div>
              </section>
              <section
                id="page-6"
                class="swiper-slide swiper-no-swiping"
                v-show="currentPage === 6"
              >
                <div class="step-title">
                  <h3><i></i>Booking Successful!</h3>
                </div>
                <div id="orderSuccessful-mod" class="orderDetial-mod">
                  <ul class="order-details">
                    <li class="storeName-col">
                      Thank you for your reservation at
                      <strong id="orderSuccessfulName">{{ storeName }}</strong>
                    </li>
                  </ul>
                  <ul class="order-details">
                    <li class="name-col">
                      Customer:
                      <strong id="orderName">
                        <span id="orderFirstName">{{ infoForm.firstName }}</span
                        >&nbsp;<span id="orderLastName">{{
                          infoForm.surname
                        }}</span>
                      </strong>
                    </li>
                  </ul>
                  <ul class="order-details">
                    <li class="date-col">
                      Date:
                      <strong id="orderDate">{{ currentDate }}</strong>
                    </li>
                    <li class="week-col">
                      On:
                      <strong id="orderWeek">{{ week }}</strong>
                    </li>
                    <li class="time-col">
                      Time:
                      <strong id="orderTime">{{ currentTime }}</strong>
                    </li>
                  </ul>
                  <ul class="order-details">
                    <li class="people-col">
                      People:
                      <strong id="orderPeople">{{ currentSize }} px</strong>
                    </li>
                    <li class="phone-col">
                      Phone:
                      <strong id="orderPhone">
                        <span
                          v-show="
                            infoForm.areaCode !== '' ||
                            infoForm.areaCode !== ' '
                          "
                          >{{ infoForm.areaCode }}
                        </span>
                        {{ infoForm.phone }}
                      </strong>
                    </li>
                  </ul>
                  <ul class="order-details">
                    <li class="email-col">
                      Email:
                      <strong id="orderEmail">{{ infoForm.email }}</strong>
                    </li>
                  </ul>
                  <ul
                    class="order-details"
                    id="depositCol"
                    v-show="depositPrice !== ''"
                  >
                    <li class="deposit-col">
                      Deposit
                      <strong id="orderDeposit"
                        >&pound;{{ depositPrice }}</strong
                      >
                    </li>
                  </ul>
                  <div class="successBtnCol">
                    <a id="backSelectDate" @click="makeAnotherBook"
                      >Make another reservation</a
                    >
                  </div>

                  <div class="successBtnCol icsBtnCol">
                    <a :href="ics_url" target="_blank" id="getICSlik">
                      <a-icon type="calendar" />Add to calendar
                    </a>
                  </div>
                </div>
              </section>
            </div>
          </article>
          <div class="swiper-pagination" v-show="currentPage !== 5">
            <button
              v-if="nextShow && currentPage !== 6 && currentPage !== 4"
              @click="next"
              id="nextToSelectSubmit"
              class="btn btn-success nextBtn nextBtn-success"
              data-style="expand-left"
              type="button"
            >
              <span class="ladda-label">NEXT</span>
            </button>
            <button
              v-if="currentPage === 4"
              id="confirmSubmit"
              class="btn btn-success nextBtn nextBtn-success"
              data-style="expand-left"
              :disabled="read"
              @click="complete(currentPage)"
              type="button"
            >
              <span class="ladda-label">COMPLETE</span>
            </button>
          </div>
        </div>
      </div>

      <div
        class="modal fade modal-default"
        role="basic"
        id="modal-ajax"
        aria-labelledby="modalDefaultLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content" id="modalAjax">
            <div class="modal-header bg-info" style="padding: 5px 10px">
              <h5
                class="modal-title"
                id="modalDefaultLabel"
                v-show="currentPage === 3"
              >
                Allergen:
              </h5>
              <h5
                class="modal-title"
                id="modalDefaultLabel"
                v-show="currentPage === 4"
              >
                Restaurant Terms And Conditions
              </h5>
              <button
                class="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div
              class="modal-body"
              id="allergyModalBody"
              v-show="currentPage === 3"
            >
              <modalAllergy></modalAllergy>
            </div>
            <div
              class="modal-body"
              id="modalAjaxBody"
              v-show="currentPage === 4"
            >
              <modalAjax></modalAjax>
            </div>
            <div class="modal-footer">
              <button
                class="btn btn-secondary"
                type="button"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                id="confirmAllergyBtn"
                @click="modalAllergyConfirm"
                v-show="currentPage === 3"
                class="btn btn-info modalBtn"
                type="button"
                data-dismiss="modal"
              >
                Confirm
              </button>
              <a-button
                id="acceptBtn"
                v-show="currentPage === 4"
                type="primary"
                data-dismiss="modal"
                @click="acceptTheTerm"
              >
                Accept
              </a-button>
            </div>
          </div>
        </div>
      </div>

      <div id="alertCol" class="" v-if="alertCol">
        <div class="alertContent">
          <p v-html="errorWords"></p>
        </div>
      </div>

      <a-modal
        v-model="timeSelectModalVisible"
        title=""
        id="timeSelectModal"
        :maskClosable="false"
        :closable="false"
        :footer="null"
      >
        <p class="mb20">
          Your reservation has been booked for<br /><span
            >{{ currentTime }}, {{ currentDate | getDateFormat }}
          </span>
        </p>
        <p class="mb20">
          For a booking of this size, the table will be reserved for (
          <span>{{ duration | getTimeLengthFormat }}</span> ).
        </p>
        <p class="mb10">Would you like to continue?</p>

        <div class="mb15">
          <a-button style="width: 60%" type="primary" @click="go2Next">
            Continue
          </a-button>
        </div>
        <div>
          <button
            style="width: 60%"
            type="button"
            class="btn cancel-btn"
            @click="hideTimeSelectModal"
          >
            Close
          </button>
        </div>
        <!-- <div class="modalFooterBtn-col">
          <button
            type="button"
            class="btn cancel-btn"
            @click="hideTimeSelectModal"
          >
            Close
          </button>
          <button type="button" class="btn ok-btn" @click="go2Next">
            Continue
          </button>
        </div> -->
      </a-modal>

      <a-modal
        :visible="largerBookingModalVisible"
        title=""
        id="largerBookFormModal"
        @cancel="cancelLargerBookClick"
        :maskClosable="false"
        :footer="null"
      >
        <p>Booking Enquiry</p>
        <a-form-model
          layout="horizontal"
          ref="largerBookForm"
          :model="largerBookForm"
          :rules="rules"
        >
          <div class="grid-col">
            <a-form-model-item ref="first_name" prop="first_name">
              <a-input
                size="large"
                v-model="largerBookForm.first_name"
                allow-clear
                placeholder="First Name"
              >
                <a-icon slot="prefix" type="user" />
              </a-input>
            </a-form-model-item>

            <a-form-model-item ref="last_name" prop="last_name">
              <a-input
                size="large"
                v-model="largerBookForm.last_name"
                allow-clear
                placeholder="Last Name"
              >
                <a-icon slot="prefix" type="solution" />
              </a-input>
            </a-form-model-item>
          </div>

          <div class="fix_icon_col" id="coversSelectFixCol">
            <!-- <a-form-model-item prop="covers" ref="covers">
              <a-input-number id="inputNumber" size="large"
                type="tel"
                allow-clear
                v-model="largerBookForm.covers"
                :min="1"
                :step="1"
                :formatter="value => `$ ${value}`.replace(/^(0+)|[^\d]+/g, '')"
                :parser="value => `$ ${value}`.replace(/^(0+)|[^\d]+/g, '')"
                 placeholder="Guests">
              </a-input-number>
            </a-form-model-item> -->

            <a-form-model-item prop="covers" ref="covers">
              <a-select
                v-model="largerBookForm.covers"
                placeholder="Guests"
                id="coversSelectCol"
              >
                <a-select-option
                  size="large"
                  v-for="(item, index) in coversSelectArr"
                  :key="index"
                  :value="item"
                >
                  {{ item }}<span v-if="item == 1"> guest </span
                  ><span v-else> guests</span>
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-icon slot="prefix" type="team" />
          </div>

          <div class="grid-col">
            <a-form-model-item prop="defaultDate" ref="defaultDate">
              <a-date-picker
                size="large"
                v-model="defaultDate"
                :default-value="defaultDate"
                :format="dateFormat"
                :allow-clear="false"
                inputReadOnly
              />
            </a-form-model-item>

            <div class="fix_icon_col" id="timeSelectFixCol">
              <a-form-model-item prop="time" ref="time">
                <a-select
                  v-model="largerBookForm.time"
                  placeholder="please select time"
                  id="timeSelectCol"
                >
                  <a-select-option
                    size="large"
                    v-for="(item, index) in timeSelectArr"
                    :key="index"
                    :value="item"
                  >
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-icon type="clock-circle" />
            </div>
          </div>

          <div id="phoneNumberCol">
            <div class="dropdown" id="mobile_areaCode">
              <button
                class="btn btn-secondary dropdown-toggle"
                id="mobile_areaCode-col"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {{ country }}
              </button>
              <AreaCodeWithSearch
                :areaCode="areaCode"
                :country="country"
                @getAreaCode="getAreaCode"
              >
              </AreaCodeWithSearch>
            </div>
            <a-form-model-item ref="phone" prop="phone">
              <a-input
                size="large"
                v-model="largerBookForm.phone"
                allow-clear
                placeholder="Phone Number: 07590012345"
                oninput="value=value.replace(/[^\d]/g,'')"
                :maxLength="15"
                type="tel"
              >
                <a-icon slot="prefix" type="phone" />
              </a-input>
            </a-form-model-item>
          </div>
          <a-form-model-item ref="email" prop="email">
            <a-input
              size="large"
              type="email"
              v-model="largerBookForm.email"
              allow-clear
              placeholder="Email"
            >
              <a-icon slot="prefix" type="mail" />
            </a-input>
          </a-form-model-item>

          <a-form-model-item ref="remark" prop="remark">
            <a-input
              size="large"
              type="textarea"
              v-model="largerBookForm.remark"
              allow-clear
              placeholder="Please enter your message here..."
            >
            </a-input>
          </a-form-model-item>
        </a-form-model>
        <div class="modalFooterBtn-col">
          <a-button size="large" @click="cancelLargerBookClick">
            CANCEL
          </a-button>
          <a-button
            size="large"
            type="primary"
            :loading="confirmLoading"
            @click="creatNewReservation"
          >
            SEND ENQUIRY
          </a-button>
        </div>
      </a-modal>

      <a-modal
        v-model="confirmedModalVisible"
        title=""
        :footer="null"
        id="confirmedModal"
        :maskClosable="false"
      >
        <div class="topIcon-col"><img src="@/assets/images/email.png" /></div>
        <p>
          Your booking has been confirmed.<br />
          If you have not received your booking confirmation email please check
          your<br /><span class="red">Spam Folder</span>.
        </p>

        <div class="modalFooterBtn-col">
          <button type="button" class="btn ok-btn" @click="hideConfirmedModal">
            OK
          </button>
        </div>
      </a-modal>

      <a-modal
        v-model="largerBookSuccessModalVisible"
        title=""
        id="successfulModal"
        :maskClosable="false"
        :footer="null"
      >
        <a-result
          status="success"
          title="Booking Request Sent"
          sub-title="Please check your emails for updates on your booking enquiry."
        >
        </a-result>

        <div class="modalFooterBtn-col">
          <button type="button" class="btn ok-btn" @click="hideSuccessModal">
            OK
          </button>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
//import { Card, createToken } from 'vue-stripe-elements';
// import jquery from '../../static/plugins/jquery/dist/jquery';
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import fullcalendar from "../../static/plugins/fullcalendar/dist/fullcalendar";
import localeAll from "../../static/plugins/fullcalendar/dist/localeAll";
import gcal from "../../static/plugins/fullcalendar/dist/gcal";
import Loading from "../components/loading.vue";
import modalAjax from "../components/modalAjax.vue";
import modalAllergy from "../components/modalAllergy.vue";
import AreaCodeWithSearch from "../components/AreaCodeWithSearch.vue";
import Opayo from "@/components/Opayo.vue";
import Map from "@/components/Map";

import { testTheme as _theme } from "@/assets/originalTheme.js";
import { allocateTheme } from "@/utils/allocateTheme";
import { configTheme } from "@/utils/theme";
const testTheme = JSON.stringify(_theme);

import axios from "axios";
var stripe = undefined;
var elements = undefined;
var card = undefined;

export default {
  name: "Reservation",
  components: {
    Loading,
    modalAjax,
    modalAllergy,
    AreaCodeWithSearch,
    Opayo,
    swiper,
    swiperSlide,
    Map,
  },
  inject: ["reload"],
  data() {
    return {
      storeLogo: "",
      storeName: "",
      storePhone: "",
      paramsValid: true,
      hidePostalCode: true,
      client_secret: "",
      // sizeArr: [1, 2, 3, 4, 5, 6, 7, 8],
      sizeArr: [],
      maxCovers: "",
      defaultCovers: [1, 2, 3, 4, 5, 6, 7, 8],
      currentSize: "",
      sizeActive: "",
      covers: "9",
      coverSelectShow: false,
      nextShow: false,
      currentPage: 0,
      currentDate: "",
      week: "",
      alertCol: false,
      currentTime: "",
      sessionArr: ["Breakfast"],
      timeActive: 0,
      timeSelectActive: ["", "", ""],
      infoForm: {
        firstName: "",
        surname: "",
        areaCode: "+44",
        phone: "",
        email: "",
        remark: "",
        allergy: "",
      },
      read: true,
      depositeArr: ["Card", "Cash", "Poynt", "Paymentsense"],
      deposite: "",
      disabledDay: [],
      selectedDate: "",
      timeArr: "",
      tableString: "",
      selectedsessionNum: 0,
      store_id: 0,
      loadingShow: true,
      stripeShow: false,
      res_id: 0,
      send_email: 0,
      send_sms: 0,
      deposit_type: 0,
      errorWords: "",
      depositPrice: "40.00",
      url_link: "/reservation/StreetAwayDemo",
      phones_rule: {
        gb: /^(\+?44|0)07\d{9}$/,
        gb2: /^(\+?44|0)7\d{9}$/,
        us: /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/,
      },
      modalShow: false,
      reservation_id: "",
      areaCode: "+44",
      country: "UK",
      allergy_show: 0,
      timeSelectModalVisible: false,
      timeSelectNextBtnShow: true,
      largerBookForm: {
        first_name: "",
        last_name: "",
        covers: undefined,
        date: null,
        time: undefined,
        areaCode: "+44",
        phone: "",
        email: "",
        remark: "",
      },
      largerBookingModalVisible: false,
      rules: {
        first_name: [
          {
            required: true,
            message: "The first name is required",
            trigger: "change",
          },
        ],
        last_name: [
          {
            required: true,
            message: "The last name is required",
            trigger: "change",
          },
        ],
        covers: [
          {
            required: true,
            message: "The number of guests is required.",
            trigger: "change",
          },
        ],
        date: [
          {
            required: true,
            message: "The date is required",
            trigger: "change",
          },
        ],
        time: [
          {
            required: true,
            message: "Please select a time",
            trigger: "change",
          },
        ],
        phone: [
          {
            required: true,
            message: "The phone number is required",
            trigger: "change",
          },
        ],
        email: [
          {
            required: true,
            message: "The email is required",
            trigger: "change",
          },
          {
            pattern:
              /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
            message: "Please enter a valid email address.",
          },
        ],
        // defaultDate: [{ required: true, message: 'The date is required', trigger: 'change' }],
      },
      dateFormat: "DD MMM YYYY",
      timeFormat: "HH:mm",
      defaultDate: moment(),
      duration: 0,
      is_holding_time: 0,
      ics_url: "javascript:void(0)",
      confirmLoading: false,
      is_show_home: 0,
      indexShow: false,
      reservationShow: true,
      banner_data: [
        {
          id: 933,
          image:
            "https://sparkepos.s3.eu-west-2.amazonaws.com/ccdb58d7b920f18fd9cf3b03aa63fab5.png",
          status: 1,
        },
        {
          id: 932,
          image:
            "https://sparkepos.s3.eu-west-2.amazonaws.com/a6dc6c5956acbb1db56f3f9855ad598f.png",
          status: 1,
        },
      ],
      info: [
        {
          id: 1,
          name: "valet_parking",
          status: 1,
        },
        {
          id: 2,
          name: "smoking_allowed",
          status: 1,
        },
        {
          id: 3,
          name: "serves_alcohol",
          status: 0,
        },
        {
          id: 4,
          name: "outdoor_seating",
          status: 1,
        },
        {
          id: 5,
          name: "smart_casual",
          status: 0,
        },
      ],
      expensive_rate: 2,
      notes: "dafadsf",
      swiperOption: {
        direction: "horizontal",
        loop: true,
        speed: 300,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true, //允许分页点击跳转
        },
      },
      address: "",
      locationLat: "",
      locationLng: "",
      mapShow: false,
      confirmedModalVisible: false,
      largerBookSuccessModalVisible: false,
      customTheme: {},
      parentWidth: 600,
      isShowCustomSize: false,
      tempCustomSize: 6,

      // currentDate: "24 May 2024",
      // currentPage: 4,
      // currentSize: 2,
      // currentTime: "04:30",
      // infoForm: {
      //   email: "df@setInterval.com",
      //   firstName: "Victor",
      //   surname: "JIANG",
      //   phone: "15455668834",
      // },
      // week: 23,
    };
  },
  computed: {
    timeSelectArr() {
      let h = 0;
      let interval = 15;
      let time = 0;
      let curArr = [];
      for (let i = 0; i <= 95; i++) {
        if (time == 60) {
          time = 0;
          h = h + 1;
        }
        let s = (h > 9 ? h : "0" + h) + ":" + (time > 0 ? time : "00");
        time = time + interval;
        curArr.push(s);
      }
      return curArr;
      console.log(curArr);
    },
    coversSelectArr() {
      var openData = [];
      for (var i = 1; i < 101; i++) {
        openData.push(i);
      }
      JSON.stringify(openData);
      return openData;
    },
    isFrame() {
      return this.$route.query.is_frame == 1;
    },
    isNarrowTop() {
      return false;
      return this.currentPage >= 3;
    },
  },
  filters: {
    coverFormat: function (value) {
      if (value == 1) {
        return value + " guest";
      } else if (value > 1) {
        return value + " guests";
      }
    },
  },
  created() {
    this.loadingShow = true;
    var store_name = this.$route.params.store_name;

    if (store_name != 0) {
      this.getStoreData(store_name);
    }
  },
  filters: {
    getDateFormat: function (value) {
      return moment(value).format("DD MMM, YYYY");
    },
    getTimeLengthFormat(minutes) {
      var hours, result_time;
      if (minutes !== "0" && minutes !== "" && minutes !== null) {
        hours = minutes / 60;
        var arr = new Array();
        arr = hours.toFixed(2).toString().split(".");
        var min_time;
        if (arr[1] > 0) {
          min_time = "0." + arr[1];
          min_time = Number(min_time) * 60;
          if (arr[0] > 0) {
            result_time = arr[0] + "h " + min_time + "min";
          } else {
            result_time = min_time + "min";
          }
        } else {
          result_time = arr[0] + " hours";
        }
      }
      return result_time;
    },
    getInfoName(value) {
      var name,
        arr = new Array();
      arr = value.split("_");
      name = arr[0] + " " + arr[1];
      if (name == "smoking allowed") {
        return "smoking area";
      }
      if (name == "valet parking") {
        return "parking";
      }
      if (name == "smart casual") {
        return "dog friendly";
      }
      return name;
    },
  },
  methods: {
    getStoreData(store_name) {
      axios
        .get(process.env.API_URL + "htmlReserve/getStoreData", {
          params: { store_name: store_name },
        })
        .then((res) => {
          console.log(res.data.data);
          localStorage.setItem("store_data", JSON.stringify(res.data.data));
          if (res.data.code == -1) {
            this.errorWords = res.data.message;
            setTimeout(this.alertTips, 100);
            $("#nextToSelectSubmit").hide();
          } else {
            try {
              if (res.data.data.style_status == 1) {
                console.log(res.data.data.style_content);
                this.customTheme = res.data.data.style_content;
                const { brandColor, fontColor } = this.customTheme;
                configTheme(brandColor, fontColor);
              } else {
                configTheme("#f08a24", "#000000");
              }
            } catch (error) {
              console.log("转换style_content1", error);
            }
            this.store_id = res.data.data.store_id;
            localStorage.setItem("store_id", res.data.data.store_id);
            this.storeName = res.data.data.store_name;
            this.storeLogo = res.data.data.logo;
            this.storePhone = res.data.data.contact_phone;
            this.maxCovers = res.data.data.covers;
            this.is_show_home = res.data.data.is_show_home;
            if (res.data.data.is_show_home == 1) {
              this.indexShow = true;
              this.reservationShow = false;
            } else {
              this.indexShow = false;
              this.reservationShow = true;
            }
            this.banner_data = res.data.data.banner_data;
            this.expensive_rate = res.data.data.expensive_rate;
            this.info = res.data.data.info;
            this.notes = res.data.data.notes;

            var address_1 = "",
              address_2 = "";
            if (res.data.data.address != "") {
              address_1 = res.data.data.address + "<br>";
            }
            if (res.data.data.address2 != "") {
              address_2 = res.data.data.address2;
            }

            this.address = address_1 + address_2;

            this.locationLat = res.data.data.lat;
            this.locationLng = res.data.data.lng;

            var coversData = [];
            for (var i = 1; i < this.maxCovers + 1; i++) {
              coversData.push(i);
            }
            JSON.stringify(coversData);
            this.sizeArr = coversData;

            this.url_link = "/reservation/" + this.storeName;
            //          if(res.data.data.stripe_pk != -1){
            //              stripe = Stripe(res.data.data.stripe_pk);
            //              elements = stripe.elements();
            //              card=elements.create('card');
            //              card.mount(this.$refs.card);
            //          }
            this.loadingShow = false;
          }
        });
    },
    getReserveData(res_id) {
      axios
        .get(process.env.API_URL + "htmlReserve/getReserveData", {
          params: { reserve_id: res_id },
        })
        .then((res) => {
          this.storeName = res.data.data.store_name;
          this.infoForm.firstName = res.data.data.cust_first_name;
          this.infoForm.surname = res.data.data.cust_surname;
          this.currentDate = res.data.data.date;
          this.week = res.data.data.wekday;
          this.currentTime = res.data.data.r_time;
          this.currentSize = res.data.data.covers;
          this.infoForm.phone = res.data.data.cust_phone;
          this.infoForm.email = res.data.data.cust_email;
          if (res.data.data.slogo != 1) {
            this.storeLogo = res.data.data.slogo;
          }
        });
    },

    getReserveTime(store_id, customerNum, date, sessionNum) {
      axios
        .get(process.env.API_URL + "htmlReserve/getReserveTime", {
          params: {
            store_id: store_id,
            customerNum: customerNum,
            date: date,
            sessionNum: sessionNum,
          },
        })
        .then((res) => {
          // console.log(res);
          if (res.data.code == 200) {
            this.sessionArr = res.data.data.sessioon_arr;
            this.timeArr = res.data.data.time_arr;

            this.selectedsessionNum =
              res.data.data.sessioon_arr[this.timeActive].id;
            this.is_holding_time =
              res.data.data.sessioon_arr[this.timeActive].is_holding_time;

            var duration_arr = this.sessionArr[this.timeActive].durationas_set;
            var duration_data = duration_arr.split(",");

            if (this.currentSize <= 7) {
              var i = this.currentSize - 1;
              this.duration = duration_data[i];
            } else if (this.currentSize > 7) {
              this.duration = duration_data[7];
            }
            // console.log(this.duration)

            this.loadingShow = false;
            var signleDeposit =
              res.data.data.sessioon_arr[this.timeActive].deposit;
            var total = (signleDeposit * this.currentSize) / 100;
            this.depositPrice = total.toFixed(2);
            localStorage.setItem("depositPrice", total.toFixed(2));
            this.allergy_show =
              res.data.data.sessioon_arr[this.timeActive].is_open_allergen;
          } else {
            this.errorWords = res.data.message;
            setTimeout(this.alertTips, 100);
            this.prev();
            this.loadingShow = false;
            $("#nextToSelectSubmit").hide();

            // location.reload();
          }
        });
    },

    getWidgetReserveDate(store_id, selectedCustNumber) {
      axios
        .get(process.env.API_URL + "htmlReserve/getWidgetReserveDate", {
          params: { store_id: store_id, custNum: this.currentSize },
        })
        .then((res) => {
          //  console.log(res.data.data.disabled);
          this.disabledDay = res.data.data.disabled;
          $("#dateSelect-calendar").fullCalendar("destroy");
          this.selectDate(this.disabledDay);
          this.loadingShow = false;
        });
    },
    prepare(amount, store_id, reserve_id) {
      axios
        .get(process.env.API_URL + "htmlReserve/getCardInfo", {
          params: { store_id: store_id, reserve_id: reserve_id },
        })
        .then((res) => {
          console.log({ store_id: store_id, reserve_id: reserve_id });
          console.log(res);
          this.card = res.data.data;
          this.res_id = reserve_id;
        });
    },

    payDeposit(store_id, reserve_id, deposit, user_id) {
      axios
        .post(process.env.API_URL + "pay/stripePay", {
          params: {
            store_id: store_id,
            reserve_id: reserve_id,
            deposit: deposit,
            user_id: user_id,
          },
        })
        .then((res) => {
          var pk = res.data.data.pk;
          var striped = Stripe(pk);
          striped
            .redirectToCheckout({
              sessionId: res.data.data.id,
            })
            .then(function (result) {
              // If `redirectToCheckout` fails due to a browser or network
              // error, display the localized error message to your customer
              // using `result.error.message`.
            });
        });
    },

    createWebPend(
      first_name,
      last_name,
      store_id,
      currentDate,
      currentTime,
      infoForm,
      currentSize,
      send_email,
      areacode,
      phone
    ) {
      axios
        .post(process.env.API_URL + "pend/create", {
          store_id: store_id,
          date: currentDate,
          start_time: currentTime,
          notes: infoForm,
          covers: currentSize,
          email: send_email,
          areacode_p: areacode,
          first_name: first_name,
          last_name: last_name,
          phone: phone,
        })
        .then((res) => {
          // if (res.data.code==200) {
          //     this.confirmLoading = false
          //     this.cancelLargerBookClick()
          // }
        });
    },

    createWebReserve(
      store_id,
      currentDate,
      currentTime,
      infoForm,
      tableString,
      currentSize,
      selectedsessionNum,
      send_email,
      send_sms
    ) {
      axios
        .post(process.env.API_URL + "htmlReserve/createWebReserve", {
          params: {
            store_id: store_id,
            currentDate: currentDate,
            currentTime: currentTime,
            infoForm: infoForm,
            tableString: tableString,
            currentSize: currentSize,
            selectedsessionNum: selectedsessionNum,
            send_email: send_email,
            send_sms: send_sms,
          },
        })
        .then((res) => {
          console.log(res.data);
          this.reservation_id = res.data.data.id;
          localStorage.setItem("reservation_id", res.data.data.id);
          localStorage.setItem(
            "opayo_set_status",
            res.data.data.opayo_set_status
          );
          localStorage.setItem(
            "viva_set_status",
            res.data.data.viva_set_status
          );
          this.ics_url = res.data.data.ics_url;

          if (res.data.code == 200) {
            this.loadingShow = false;
            if (res.data.data.amount > 0) {
              localStorage.setItem("priceTotal", res.data.data.amount);
              //20220923
              // this.prepare(res.data.data.amount, store_id, res.data.data.id);
              // this.modalShow = true
              this.$router.push({
                path: "/selectcard",
              });
            } else {
              this.currentPage = 6;
              this.confirmedModalVisible = true;
              this.loadingShow = false;
            }
          } else {
            this.currentPage = 5;
          }
        });
    },

    purchase() {
      this.loadingShow = true;
      let self = this;
      stripe
        .confirmCardPayment(this.client_secret, {
          payment_method: {
            card: card,
            billing_details: {
              name: this.infoForm.firstName + " " + this.infoForm.surname,
            },
          },
        })
        .then(function (result) {
          console.log(result);
          if (result.error) {
            self.loadingShow = false;
            self.hasCardErrors = true;
            self.errorWords = "This card number is wrong.";
            setTimeout(self.alertTips, 100);
            self.$forceUpdate(); // Forcing the DOM to update so the Stripe Element can update.
            return;
          } else {
            if (result.paymentIntent.status === "succeeded") {
              axios
                .get(process.env.API_URL + "htmlReserve/depositSuccess", {
                  params: {
                    paymentIntent_id: result.paymentIntent.id,
                    amount: result.paymentIntent.amount,
                  },
                })
                .then((res) => {
                  console.log(res);
                  window.location.href = res.data.data.return_url;
                });
            } else {
              self.loadingShow = false;
              self.hasCardErrors = true;
              self.errorWords =
                "Payment failed, please fill in the card information and submit again.";
              setTimeout(self.alertTips, 100);
              // location.reload();
            }
          }
        });
    },
    setSendEmail() {
      if (this.send_email == 0) {
        this.send_email = 1;
      } else {
        this.send_email = 0;
      }
    },
    setSendSms() {
      if (this.send_sms == 0) {
        this.send_sms = 1;
      } else {
        this.send_sms = 0;
      }
    },

    destroy(visible) {
      this.stripeShow = false;
      // Stripe.instance = null;
      // Stripe.elements = null;
      // Stripe.createToken = null;
      Stripe.instance = null;
      Stripe.elements = null;
      Stripe.createToken = null;
    },
    //选择party size
    changeSize(val, index) {
      this.currentSize = val;
      this.sizeActive = val;
      this.coverSelectShow = false;
      if (!this.nextShow) this.nextShow = true;
      $("#nextToSelectSubmit").show();
    },

    confirmCustomSize() {
      this.covers = this.tempCustomSize;
      this.coverSelectShow = true;
      this.currentSize = this.tempCustomSize;
      this.sizeActive = this.tempCustomSize;

      if (!this.nextShow) this.nextShow = true;
    },
    startCustomSize() {
      this.isShowCustomSize = true;
      this.nextShow = true;
      this.covers = this.tempCustomSize;
      this.currentSize = this.tempCustomSize;
      this.sizeActive = this.tempCustomSize;
    },
    changeCustomSize(val) {
      this.covers = this.tempCustomSize;
      this.coverSelectShow = true;
      this.currentSize = this.tempCustomSize;
      this.sizeActive = this.tempCustomSize;
    },

    changeCover() {
      this.currentSize = this.covers;
      this.sizeActive = this.covers;

      if (!this.nextShow) this.nextShow = true;
      $("#nextToSelectSubmit").show();
    },

    // 上一步
    prev() {
      if (this.currentPage) {
        this.currentPage--;
        // if(this.timeSelectNextBtnShow == false && this.currentPage==2){
        if (this.currentPage == 0) {
          this.currentSize = "";
          this.sizeActive = "";
          $("#selectPartySize-mod")
            .find(".partySizeLabel")
            .removeClass("active");
          this.week = "";
          this.currentDate = "";
          $("#dateSelect-calendar").find("a").removeClass("selected-date");
          // $('#grid-date-col').html('');
          $("#date").val("");

          this.currentTime = "";
          $("#selectTime-mod").find(".timeLabel").removeClass("active");
          $("#nextToSelectSubmit").hide();
        } else if (this.currentPage == 1) {
          this.week = "";
          this.currentDate = "";
          $("#dateSelect-calendar").find("a").removeClass("selected-date");
          // $('#grid-date-col').html('');
          $("#date").val("");
          $("#nextToSelectSubmit").hide();
        } else if (this.currentPage == 2) {
          this.currentTime = "";
          $("#selectTime-mod").find(".timeLabel").removeClass("active");
          $("#nextToSelectSubmit").hide();
        } else {
          $("#nextToSelectSubmit").show();
        }
        // if(this.currentPage==2){
        //      this.currentTime = ''
        // 	$("#nextToSelectSubmit").hide();
        // }else{
        // 	$("#nextToSelectSubmit").show();
        // }
      }
    },
    // 下一步
    next() {
      if (
        this.currentPage < 6 &&
        this.currentPage !== 5 &&
        this.currentPage !== 4 &&
        this.currentPage !== 3
      ) {
        $("#nextToSelectSubmit").hide();
      }
      if (this.currentPage < 6 && this.currentPage !== 4) {
        if (this.currentPage === 3) {
          this.submitInfo();
          //				$("#nextToSelectSubmit").show();
        }
        if (this.paramsValid) {
          this.currentPage++;
        }
      }

      // if(this.currentPage === 0) {
      // // this.stripePay();
      //   this.loadingShow=true;
      //   this.getWidgetReserveDate(this.store_id,this.sizeActive);

      // }

      if (this.currentPage === 1) {
        // this.stripePay();
        this.loadingShow = true;
        this.getWidgetReserveDate(this.store_id, this.sizeActive);
      }
      if (this.currentPage === 2) {
        this.selectedDate = $("#date").val();
        this.loadingShow = true;
        this.getReserveTime(
          this.store_id,
          this.sizeActive,
          this.selectedDate,
          0
        );
      }

      if (this.currentPage === 3) {
        $("#nextToSelectSubmit").show();
      }
      if (this.currentPage === 4) {
        // if($.trim(this.infoForm.areaCode)=='+44'){
        //
        //  // if(!this.phones_rule.gb.test(this.infoForm.areaCode+this.infoForm.phone)   &&  !this.phones_rule.gb2.test(this.infoForm.areaCode+this.infoForm.phone) ) {
        //  //   this.currentPage = 3;
        //  //   this.errorWords = 'Please enter the correct phone number';
        //  //   setTimeout(this.alertTips,100);
        //  // }
        // }
      }
    },
    alertTips() {
      this.alertCol = true;
      setTimeout(() => {
        this.alertCol = false;
      }, 1000);
    },
    timeTabs(index) {
      this.timeActive = index;

      this.selectedsessionNum = this.sessionArr[index].id;
      var duration_arr = this.sessionArr[index].durationas_set;
      var duration_data = duration_arr.split(",");

      if (this.currentSize <= 7) {
        var i = this.currentSize - 1;
        this.duration = duration_data[i];
      } else if (this.currentSize > 7) {
        this.duration = duration_data[7];
      }

      this.getReserveTime(
        this.store_id,
        this.sizeActive,
        this.selectedDate,
        this.selectedsessionNum
      );
    },
    selectTime(val, index, ind, tableString, show) {
      if (show == 1) {
        this.currentTime = val;
        this.timeSelectActive.fill("");
        this.timeSelectActive[ind] = index;
        this.tableString = tableString;
        $("#nextToSelectSubmit").show();
        // $("#nextToSelectSubmit").hide()
        this.selectedDate = $("#date").val();
        this.currentPage = 3;
        this.loadingShow = true;
        this.getReserveTime(
          this.store_id,
          this.sizeActive,
          this.selectedDate,
          0
        );
      } else {
        this.currentTime = "";
        $("#nextToSelectSubmit").hide();
      }

      if (this.currentTime !== "") {
        $("#nextToSelectSubmit").show();
        // $("#nextToSelectSubmit").hide()
        this.selectedDate = $("#date").val();
        this.currentPage = 3;
        this.loadingShow = true;
        this.getReserveTime(
          this.store_id,
          this.sizeActive,
          this.selectedDate,
          0
        );
      }
    },
    chooseTime(val, index, ind, tableString, show) {
      if (show == 1) {
        this.currentTime = val;
        this.timeSelectActive.fill("");
        this.timeSelectActive[ind] = index;
        this.tableString = tableString;
        var self = this;
        this.timeSelectModalVisible = true;
      } else {
        this.currentTime = "";
        // $("#nextToSelectSubmit").hide()
      }

      if (this.currentTime !== "") {
        // $("#nextToSelectSubmit").show()
      }
    },
    hideTimeSelectModal() {
      this.timeSelectModalVisible = false;
    },
    go2Next() {
      this.timeSelectModalVisible = false;
      this.timeSelectNextBtnShow = false;
      this.next();
    },
    largerBookBtn() {
      this.currentSize = "";
      $("#nextToSelectSubmit").hide();
      this.largerBookingModalVisible = true;
      this.areaCode = "+44";
      this.country = "UK";
    },
    cancelLargerBookClick() {
      this.largerBookingModalVisible = false;
      this.$refs.largerBookForm.resetFields();
    },
    creatNewReservation() {
      this.loadingShow = true;
      this.$refs.largerBookForm.validate((valid) => {
        if (valid) {
          this.largerBookForm.date = moment(this.defaultDate).format(
            "YYYY-MM-DD"
          );
          this.largerBookForm.areaCode = this.areaCode;

          console.log(this.largerBookForm);
          this.createWebPend(
            this.largerBookForm.first_name,
            this.largerBookForm.last_name,
            this.store_id,
            this.largerBookForm.date,
            this.largerBookForm.time,
            this.largerBookForm.remark,
            this.largerBookForm.covers,
            this.largerBookForm.email,
            this.largerBookForm.areaCode,
            this.largerBookForm.phone
          );
          this.loadingShow = false;
          this.cancelLargerBookClick();
          this.largerBookSuccessModalVisible = true;
        } else {
          this.loadingShow = false;
          return false;
        }
      });
    },
    hideSuccessModal() {
      this.largerBookSuccessModalVisible = false;
      this.reload();
    },
    makeAnotherBook() {
      this.reload();
    },
    go2AddReservation() {
      this.indexShow = false;
      this.reservationShow = true;
    },
    getMap() {
      // this.locationLat
      // this.locationLng
      this.mapShow = true;
    },
    hideConfirmedModal() {
      this.confirmedModalVisible = false;
    },
    submitInfo() {
      let self = this;
      $("#reservationForm").valid();
      let form = $("#reservationForm");
      if (!form.valid()) {
        this.paramsValid = false;
      } else {
        self.infoForm.areaCode = self.areaCode;
        this.paramsValid = true;
      }
    },
    readNot() {
      this.read = false;
    },
    acceptTheTerm() {
      // this.readNot()
      $(".readTermRadioCol").find("input[type=radio]").click();
      this.read = false;
    },
    complete(page) {
      console.log(page);
      this.loadingShow = true;
      this.createWebReserve(
        this.store_id,
        this.currentDate,
        this.currentTime,
        this.infoForm,
        this.tableString,
        this.currentSize,
        this.selectedsessionNum,
        this.send_email,
        this.send_sms
      );

      //	this.currentPage = 5;
    },
    depositeTabs(val) {
      this.deposite = val;
    },
    modalAllergyConfirm() {
      var customer = {};
      let form = $("#selectAllergyForm");
      let formData = form.serializeJSON();
      var allergySelectedStr = "";
      var allergySelectedData = [];
      $("#modalAjax")
        .find('input[name="allergy-checkbox"]:checked')
        .each(function () {
          allergySelectedData.push($(this).val());
          allergySelectedStr += $(this).val() + ", ";
        });
      $("#allergy_data").val(allergySelectedData);
      customer.allergy_json = allergySelectedData;
      this.infoForm.allergy = allergySelectedStr;
    },
    allergySelect() {
      if ($("#allergy_data").val() === "") {
        $("#modalAjax")
          .find('input[name="allergy-checkbox"]:checked')
          .each(function () {
            $(this).prop("checked", false);
          });
      }
    },
    termsAndConditions() {
      // $('#acceptBtn').unbind("click").on('click', function () {
      // 	$("#radio-check").prop("checked",true);
      //     $('#confirmSubmit').prop("disabled",false);
      // });
    },
    selectDate(disabledDay) {
      let self = this;
      $(".swiper-slide.swiper-no-swiping").hide();
      $("#page-2").show();
      //		$("#grid-date-col").empty();
      //		$("#nextToSelectSubmit").hide()
      $("#dateSelect-calendar").fullCalendar("destroy");

      $("#dateSelect-calendar").fullCalendar({
        header: {
          left: "title",
          right: "prev,next today",
          center: "",
        },
        buttonIcons: {
          prev: " ti-arrow-left",
          next: " ti-arrow-right",
        },
        firstDay: 1,
        //	        businessHours: true, // display business hours
        selectable: false,
        selectHelper: false,
        editable: false, // stop drog
        eventLimit: false, // stop move "more" link when too many events
        defaultView: "month",
        fixedWeekCount: false,
        viewRender: function (view, element, currentView) {
          var minDate = moment().format("YYYY-MM-DD");
          var maxDate = moment().add(3, "months").format("YYYY-MM-DD");
          $(".fc-day-top").each(function () {
            var t = $(this);
            if (t.data("date") > maxDate || t.data("date") < minDate) {
              t.addClass("cannotAdd");
            } else {
              t.addClass("canAdd");
            }
            $.each(disabledDay, function (i, v) {
              if (t.data("date") == v) {
                t.removeClass("canAdd");
                t.addClass("cannotAdd");
              }
            });
          });

          var startDate = moment();
          var endDate = moment().add(3, "months");

          if (startDate >= currentView.start && startDate <= currentView.end) {
            $(".fc-prev-button").prop("disabled", true);
            $(".fc-prev-button").addClass("fc-state-disabled");
          } else {
            $(".fc-prev-button").removeClass("fc-state-disabled");
            $(".fc-prev-button").prop("disabled", false);
          }

          if (endDate >= currentView.start && endDate <= currentView.end) {
            $(".fc-next-button").prop("disabled", true);
            $(".fc-next-button").addClass("fc-state-disabled");
          } else {
            $(".fc-next-button").removeClass("fc-state-disabled");
            $(".fc-next-button").prop("disabled", false);
          }

          $(".fc-row.fc-week.fc-widget-content").each(function () {
            var rowHeight = $(this).height();
            $(this)
              .find(
                ".fc-content-skeleton, .fc-content-skeleton table, .fc-content-skeleton td"
              )
              .height(rowHeight);
            $(this)
              .find(".fc-day-number")
              .css("height", rowHeight - 4);
            var lineHeight = rowHeight - 4;
            $(this)
              .find(".fc-day-number")
              .css("line-height", lineHeight + "px");
          });
          $(".fc-content-skeleton").find("tbody *").empty().remove();
        },
        navLinks: true,
        navLinkDayClick: function (date, jsEvent) {
          var reservationTime = date.format("DD MMM YYYY");
          var reservationDates = date.format("YYYY-MM-DD");
          var reservationWeek = date.format("dddd");
          //		        $('#grid-date-col').html(reservationTime).attr("week",reservationWeek);
          //		        $('#date').val(reservationDates);
          self.currentDate = reservationTime;
          self.week = reservationWeek;

          if (
            $(jsEvent.currentTarget).parent(".fc-day-top").hasClass("canAdd")
          ) {
            if (
              date >= moment().add(-1, "days") &&
              date <= moment().add(3, "months")
            ) {
              $("#dateSelect-calendar").find("a").removeClass("selected-date");
              $(jsEvent.currentTarget).addClass("selected-date");
              // $('#grid-date-col').html(reservationTime);
              $("#date").val(reservationDates);
              $("#nextToSelectSubmit").show();
            } else {
              self.errorWords =
                "The selected date is unavailable, <br />please choose another date.";
              setTimeout(self.alertTips, 100);
              $("#nextToSelectSubmit").hide();
            }
          } else {
            self.errorWords =
              "The selected date is unavailable, <br />please choose another date.";
            setTimeout(self.alertTips, 100);
            $("#nextToSelectSubmit").hide();
          }
        },
      });
      $(".fc-today-button").html('<i class="ti-world"></i>');

      $(".fc-row.fc-week.fc-widget-content").each(function () {
        var rowHeight = $(this).height();
        $(this)
          .find(
            ".fc-content-skeleton, .fc-content-skeleton table, .fc-content-skeleton td"
          )
          .height(rowHeight);
        $(this)
          .find(".fc-day-number")
          .css("height", rowHeight - 4);
        var lineHeight = rowHeight - 4;
        $(this)
          .find(".fc-day-number")
          .css("line-height", lineHeight + "px");
      });
      $(".fc-content-skeleton").find("tbody *").empty().remove();

      var defaultDate = $("#date").val();
      if (defaultDate != "") {
        $(".fc-day-top.canAdd").each(function () {
          var calendarDate = $(this).data("date");
          if (calendarDate == defaultDate) {
            $(this).find(".fc-day-number").addClass("selected-date");
            $("#nextToSelectSubmit").show();
          }
        });
      }
    },
    go2PayClick() {},
    getAreaCode(value) {
      var selectAreaCode = $(value).attr("data-code");
      var selectCountry = $(value).attr("data-country");
      this.areaCode = selectAreaCode;
      this.country = selectCountry;
      // this.largerBookForm.areaCode = this.areaCode
      console.log(selectCountry);
    },
    checkPhone(rule, value, callback) {
      const pwdRegex = new RegExp("^[1-9]\\d{0,11}$");
      if (!pwdRegex.test(value)) {
        callback(new Error("Please enter a valid phone number."));
      }
      callback();
    },
    checkEmail(rule, value, callback) {
      const pwdRegex = new RegExp(
        "/^w{3,}(.w+)*@[A-z0-9]+(.[A-z]{2,5}){1,2}$/"
      );
      if (!pwdRegex.test(value)) {
        callback(new Error("Please enter a valid email address."));
      }
      callback();
    },

    // 2023-07-24 自定义界面样式
    // async getCustomStyle() {
    //   // const res = await axios.get(process.env.API_URL + 'htmlReserve/getWidgetReserveDate', { params: { store_id: store_id } })

    //   const res = {
    //     party_size: {
    //       title: {
    //         fontSize: "20px",
    //         color: "orange",
    //         backgroundColor: "blue",
    //       },
    //       subTitle: {
    //         fontSize: "24px",
    //         color: "green",
    //         backgroundColor: "pink",
    //       },
    //     },
    //   };

    //   this.customTheme = res;

    //   // 动态插入style
    //   function loadCssCode(code) {
    //     var style = document.createElement("style");
    //     style.type = "text/css";
    //     style.rel = "stylesheet";
    //     //for Chrome Firefox Opera Safari
    //     style.appendChild(document.createTextNode(code));
    //     //for IE
    //     //style.styleSheet.cssText = code;
    //     var head = document.getElementsByTagName("head")[0];
    //     head.appendChild(style);
    //   }
    //   loadCssCode(".fc-header-toolbar{background-color:#f00 !important}");
    // },
  },
  mounted() {
    // this.next();
    // this.getSwiper()
    // this.getCustomStyle();

    // 监听postmessage，为了获取父页面的宽度，然后调整这个项目页面的样式
    window.addEventListener("message", (event) => {
      if (event.origin === "http://localhost:8080") return;
      console.log(event);
      if (event && event.data) {
        // const postData = JSON.parse(event.data);
        console.log(event.data);
        if (event.data.parentWidth) {
          // 监听的是父页面的宽度
          this.parentWidth = event.data.parentWidth;
        }
      }
    });

    $("#reservationForm").validate({
      rules: {
        first_name: {
          required: true,
          minlength: 2,
        },
        surname: {
          required: true,
          minlength: 2,
        },
        phone: {
          required: true,
          minlength: 10,
        },
        email: "required",
      },
      messages: {
        first_name: {
          required: "The first name cannot be empty",
          minlength: "Your first name must consist of at least 2 characters",
        },
        surname: {
          required: "The last name cannot be empty",
          minlength: "Your last name must consist of at least 2 characters",
        },
        phone: {
          required: "The mobile number cannot be empty",
          minlength: "Your mobile number must be at least 11 characters long",
        },
        email: {
          required: "Email cannot be empty",
          minlength: "Please enter a valid email address",
        },
      },
      errorElement: "div",
      errorClass: "form-control-feedback",
      errorPlacement: function (error, element) {
        // Add the `help-block` class to the error element
        error.addClass("form-control-feedback");

        if (element.prop("type") === "checkbox") {
          error.appendTo(element.parents(".input-group"));
        } else if (element.prop("type") === "file") {
          error
            .addClass("error-words")
            .insertAfter(element.parents(".error-col").find(".error-words"));
        } else {
          error.appendTo(element.parent(".input-group"));
        }
      },
      highlight: function (element, errorClass, validClass) {
        $(element)
          .parents(".input-group")
          .addClass("has-danger")
          .removeClass("has-success");
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element)
          .parents(".input-group")
          .addClass("has-success")
          .removeClass("has-danger");
      },
    });
  },
};
</script>
<style scoped="scoped">
#all-covers {
  border-color: var(--brandColor);
}

.select-col select {
  outline: none;
  -webkit-appearance: none;
  position: relative;
}

.select-col::after {
  position: absolute;
  content: "";
  display: block;
  width: 0;
  height: 0;
  right: 10px;
  top: 15px;
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-left: 0.3em solid transparent;
  border-color: #3d1cba transparent transparent transparent;
}

#reservation #selectPartySize-mod .radioButtonCol.grid_3 {
  grid-template-columns: repeat(3, 1fr);
}

.company-logo {
  width: 100px;
  height: 100px;
}
</style>
<style lang="scss" scoped>
.isFrame {
  #page-index,
  .page-content {
    overflow-y: unset !important;
  }
  &.isWideScreen {
    #page-index,
    .page-content {
      max-width: 65% !important;
    }
  }

  #main-menu,
  #main-nav,
  #main-title {
    width: 100%;
    position: relative !important;
    transform: unset !important;
    max-width: unset !important;
    top: unset !important;
    left: unset !important;
  }
  .swiper-container {
    overflow-y: auto !important;
    padding-top: 0 !important;
  }
}
.tip-grid-col {
  display: flex;
  align-items: center;
  justify-content: center;
}
#reservation nav.detail-nav {
  border-top: 0;
  border-bottom: 0;
}
#calendar-modal {
  margin-top: 20px;
}
.step-title {
  margin-bottom: 10px;
}
.tip-grid-col-bottom {
  height: 27px;
}

.isNarrowTop {
  #reservation {
    .logo-header {
      height: 74px;
    }
  }
}
.btn {
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/page/Reservation.vue